module.exports = __webpack_public_path__ + "static/media/tire.f2b3d91f.svg";